export const activityStatusMap = [
    {
        label: '待审核',
        value: 'UN_AUDIT',
        color: 'red'
    },
    {
        label: '驳回',
        value: 'REJECTED',
        color: 'red'
    },
    {
        label: '待开始',
        value: 'UN_START',
        color: 'red'
    },
    {
        label: '进行中',
        value: 'RUNNING',
        color: 'cyan'
    },
    {
        label: '已结束',
        value: 'FINISHED',
        color: ''
    }
]
